import { Stack } from '@mui/material';
import { NextPrevButton } from './NextPrevButton';
import { PageButton } from './PageButton';
import { Dots } from './Dots';
import React from 'react';

interface IPagination {
  currentPage: number;
  setCurrentPage: Function;
  totalPages: number;
}

export const Pagination = ({
  currentPage,
  setCurrentPage,
  totalPages,
}: IPagination) => {
  const DOTS_DIFFERENCE_RENDER = 3;

  const pageBtnCreator = (pageNumber: number, isActive?: boolean) => {
    return (
      <PageButton
        key={pageNumber}
        isActivePage={isActive}
        pageNumber={pageNumber}
        setCurrentPage={setCurrentPage}
      />
    );
  };

  const pagesButtonsGroupHandler = () => {
    const pageButtons: React.ReactNode[] = [];

    if (currentPage === 0) {
      pageButtons.push([
        pageBtnCreator(currentPage + 1),
        pageBtnCreator(currentPage + 2),
      ]);
      return pageButtons;
    } else if (totalPages === currentPage) {
      pageButtons.push([
        pageBtnCreator(currentPage - 2),
        pageBtnCreator(currentPage - 1),
      ]);
      return pageButtons;
    }

    if (currentPage > 0 && currentPage < totalPages) {
      if (currentPage > 2) {
        pageButtons.push([
          pageBtnCreator(currentPage - 2),
          pageBtnCreator(currentPage - 1),
        ]);
      } else if (currentPage !== 1) {
        pageButtons.push(pageBtnCreator(currentPage - 1));
      }

      pageButtons.push(pageBtnCreator(currentPage, true));

      if (totalPages - currentPage > 2) {
        pageButtons.push([
          pageBtnCreator(currentPage + 1),
          pageBtnCreator(currentPage + 2),
        ]);
      } else if (totalPages - currentPage !== 1) {
        pageButtons.push(pageBtnCreator(currentPage + 1));
      }
    }
    return pageButtons;
  };

  const pagesButtonsSmallGroupHandler = () => {
    const pageButtons: React.ReactNode[] = [];
    for (let i = 0; i <= totalPages; i++)
      pageButtons.push(pageBtnCreator(i, i === currentPage));
    return pageButtons;
  };

  return (
    <Stack
      direction='row'
      justifyContent='center'
      alignItems='center'
      gap='8px'
      sx={{
        mt: '16px',
      }}
    >
      <NextPrevButton
        isPrev
        isActive={currentPage > 0}
        callback={() => setCurrentPage(currentPage - 1)}
      />
      {totalPages < DOTS_DIFFERENCE_RENDER ? (
        pagesButtonsSmallGroupHandler()
      ) : (
        <>
          <PageButton
            key={0}
            isActivePage={currentPage === 0}
            pageNumber={0}
            setCurrentPage={setCurrentPage}
          />
          {currentPage > DOTS_DIFFERENCE_RENDER && <Dots />}
          {pagesButtonsGroupHandler()}
          {totalPages - currentPage > DOTS_DIFFERENCE_RENDER && <Dots />}
          <PageButton
            key={totalPages}
            isActivePage={currentPage === totalPages}
            pageNumber={totalPages}
            setCurrentPage={setCurrentPage}
          />
        </>
      )}
      <NextPrevButton
        isActive={currentPage < totalPages}
        callback={() => setCurrentPage(currentPage + 1)}
      />
    </Stack>
  );
};
